import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css';// Progress 进度条样式
Vue.use(Router);
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
const routerReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Router.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error)
}
const router = new Router({
  routes: [

    {
      name: 'test',
      path: '/',
      component: () => import('@/views/0.md'),
      meta: { title: '前言', hidden: false }
    },
    {
      name: 'sjms',
      path: '/sjms',
      meta: { title: '设计模式' },
      component: () => import('./router-link.vue'),
      children: [
        {
          path: '0',
          name: '0',
          component: () => import('@/views/shejimoshi/0.md'),
          meta: { title: '基础知识准备' }
        },
        {
          path: '1',
          name: '1',
          component: () => import('@/views/shejimoshi/1.md'),
          meta: { title: '单例模式' }
        },
        {
          path: '2',
          name: '2',
          component: () => import('@/views/shejimoshi/2.md'),
          meta: { title: '策略模式' }
        },
        {
          path: '3',
          name: '3',
          component: () => import('@/views/shejimoshi/3.md'),
          meta: { title: '代理模式' }
        },
        {
          path: '4',
          name: '4',
          component: () => import('@/views/shejimoshi/4.md'),
          meta: { title: '发布-订阅模式' }
        },
        {
          path: '5',
          name: '5',
          component: () => import('@/views/shejimoshi/5.md'),
          meta: { title: '迭代器模式' }
        },
        {
          path: '6',
          name: '6',
          component: () => import('@/views/shejimoshi/6.md'),
          meta: { title: '命令模式' }
        },
        {
          path: '7',
          name: '7',
          component: () => import('@/views/shejimoshi/7.md'),
          meta: { title: '亨元模式' }
        }
      ]
    },
    {
      name: 'ymjx',
      path: '/ymjx',
      meta: { title: '源码解析' },
      component: () => import('./router-link.vue'),
      children: [
        {
          path: '0',
          name: '0',
          component: () => import('@/views/yuanmajiexi/0.md'),
          meta: { title: 'call、apply、bind' }
        },
        {
          path: '1',
          name: '1',
          component: () => import('@/views/yuanmajiexi/1.md'),
          meta: { title: 'promise' }
        },
        {
          path: '2',
          name: '2',
          component: () => import('@/views/yuanmajiexi/2.md'),
          meta: { title: '函数柯里化' }
        },
        {
          path: '3',
          name: '3',
          component: () => import('@/views/yuanmajiexi/3.md'),
          meta: { title: 'Object.assign' }
        },
        {
          path: '4',
          name: '4',
          component: () => import('@/views/yuanmajiexi/4.md'),
          meta: { title: 'instanceof' }
        },
        {
          path: '5',
          name: '5',
          component: () => import('@/views/yuanmajiexi/5.md'),
          meta: { title: '深拷贝' }
        },
        {
          path: '6',
          name: '6',
          component: () => import('@/views/yuanmajiexi/6.md'),
          meta: { title: '防抖（debounce）' }
        },
        {
          path: '7',
          name: '7',
          component: () => import('@/views/yuanmajiexi/7.md'),
          meta: { title: '节流（throttle）' }
        },
        {
          path: '8',
          name: '8',
          component: () => import('@/views/yuanmajiexi/8.md'),
          meta: { title: '订阅发布模式' }
        },
        {
          path: '9',
          name: '9',
          component: () => import('@/views/yuanmajiexi/9.md'),
          meta: { title: '双向绑定' }
        },
        {
          path: '10',
          name: '10',
          component: () => import('@/views/yuanmajiexi/10.md'),
          meta: { title: 'new' }
        }
      ]
    }
  ]
});

// 路由拦截
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
  NProgress.done();
});

export default router;
